/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationWarrantiesGroupProtectionQuery = gql`
  query GetSimulationWarrantiesGroupProtectionQuery {
    getSimulationWarrantiesGroupProtection_simulation_warranties_group_protection {
      isApplicable 
      commission {
 rates {
 value  
label  
} 
defaultRate  
rate  
}
      pricings {
 pricingCode  
pricingLabel  
isPreSelected  
optionsSelectionMode  
options {
 optionCode  
optionName  
isPreSelected  
} 
}
    }
  }
`;

export default GetSimulationWarrantiesGroupProtectionQuery;
